import { Helmet } from "react-helmet";

function About() {
  return (
    <>
      <Helmet>
        <title>About Page</title>
        <meta name="description" content="About our company" />
      </Helmet>

      <h1>About Page</h1>
      <p>This is SEO optimized about page.</p>
    </>
  );
}

export default About;